/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reporting_UsageInputs */

const en_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting & Usage`)
};

const fr_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapports et utilisation`)
};

const de_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichterstattung & Nutzung`)
};

const it_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalazione e utilizzo`)
};

const ru_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчетность и использование`)
};

const es_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informes y uso`)
};

const zh_cn2_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报告与使用情况`)
};

const ja_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報告と使用状況`)
};

const hi_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिपोर्टिंग और उपयोग`)
};

const pt_pt2_reporting_usage = /** @type {(inputs: Reporting_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatórios e Utilização`)
};

/**
* | output |
* | --- |
* | "Reporting & Usage" |
*
* @param {Reporting_UsageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reporting_usage = /** @type {((inputs?: Reporting_UsageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reporting_UsageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reporting_usage(inputs)
	if (locale === "de") return de_reporting_usage(inputs)
	if (locale === "it") return it_reporting_usage(inputs)
	if (locale === "ru") return ru_reporting_usage(inputs)
	if (locale === "es") return es_reporting_usage(inputs)
	if (locale === "zh-CN") return zh_cn2_reporting_usage(inputs)
	if (locale === "ja") return ja_reporting_usage(inputs)
	if (locale === "hi") return hi_reporting_usage(inputs)
	if (locale === "pt-PT") return pt_pt2_reporting_usage(inputs)
	return en_reporting_usage(inputs)
});